/**
 * 相対パス（/始まり）のみ許可し、外部URLやjavascript:スキームを防ぐ
 * - プロトコル相対URL（//example.com）を除外
 * - バックスラッシュを除外（/\evil.com がブラウザで //evil.com に正規化されるため）
 * - 制御文字を除外（/%0a//evil.com などがブラウザで //evil.com に正規化されるため）
 */
export const getSafeRedirectUri = (uri: string | null | undefined, fallback = '/mypage'): string => {
  const hasControlChar = (uri ?? '').split('').some((c) => c.charCodeAt(0) < 32);
  if (uri?.startsWith('/') && !uri.startsWith('//') && !uri.includes('\\') && !hasControlChar) {
    return uri;
  }
  return fallback;
};

/**
 * 同一オリジンの絶対URL（API が生成する `${WEB_APP_URL}/app` など）はパスに変換し、それ以外のオリジンは fallback にする
 */
export const getSafeSameOriginRedirectUri = (uri: string | null | undefined, origin: string, fallback = '/mypage'): string => {
  if (!uri) return fallback;
  try {
    const url = new URL(uri, origin);
    if (url.origin !== origin) return fallback;
    return getSafeRedirectUri(`${url.pathname}${url.search}${url.hash}`, fallback);
  } catch {
    return fallback;
  }
};
